import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	align-items: center;
`;

export const Icon = styled.img`
	height: 35px;

	@media (max-width: 1200px) {
		height: 29px;
	}

	@media (max-width: 992px) {
		height: 26px;
	}

	@media (max-width: 768px) {
		height: 23px;
	}

	@media (max-width: 600px) {
		height: 21px;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	font-style: normal;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_primary_lightest_title};

	padding-bottom: 20px;
`;

export const ContentButton = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

export const ContentTitle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	color: ${tokens.color_primary_lightest_title};

	padding-bottom: 20px;
`;

export const ContainerSpinner = styled.div`
	padding-top: 50px;
`;
